import { postAdvertisingLeadFormArgsToParams } from 'data/api/transformers/arguments/post-advertising-lead-form-args-to-params'
import { PostAdvertisingLeadFormArgs } from 'types/api/arguments/post-advertising-lead-form-args'

import { api } from './api'

export const postAdvertisingLeadForm = (args: PostAdvertisingLeadFormArgs) =>
  api.post('/ads/lead', postAdvertisingLeadFormArgsToParams(args))
